import { find } from 'lodash'

import { SelectOption } from '../classes'
import { CampaignEventTriggers, CampaignNodeActionTypes } from '../data'
import { Campaign, CampaignNode, CampaignNodeModel, MessageTemplateModel } from '../model'

export function getCampaignTriggerViewValue(value: Campaign.TRIGGER | null): string {
  if (value == null) return ''
  let options: SelectOption<Campaign.TRIGGER>[] = []
  for (const group of CampaignEventTriggers) {
    options = options.concat(group.options)
  }
  const option = options.find((o) => o.value === value)
  return option ? option.viewValue : ''
}

export function getCampaignNodeActionType(
  node: CampaignNodeModel,
  templates: MessageTemplateModel[] = [],
): string {
  const action = node.properties.action?.type
  const templateId = node.properties.action?.templateId
  let templateName = ''

  if (templateId) {
    const template = templates.find((t) => t.id === templateId)
    templateName = template ? template.name : ''
  }

  const actions = find(
    CampaignNodeActionTypes,
    (option: SelectOption<string>) => option.value === action,
  )
  return actions?.viewValue + (templateName ? ` <br> <strong>${templateName}</strong>` : '')
}

export function getCampaignNodeDescription(
  node: CampaignNodeModel,
  campaign: { name: string; trigger: Campaign.TRIGGER },
  templates: MessageTemplateModel[] = [],
): string {
  switch (node.type) {
    case CampaignNode.TYPE.ACTION:
      return getCampaignNodeActionType(node, templates)
    case CampaignNode.TYPE.BRANCH:
      return 'Appointment ' + node.properties.appointment
    case CampaignNode.TYPE.DELAY:
      return 'Delay for ' + node.properties.delayDays + ' day(s)'
    case CampaignNode.TYPE.GOTO:
      return 'Go to action'
    case CampaignNode.TYPE.TRIGGER:
      return campaign
        ? campaign.name + ' - ' + getCampaignTriggerViewValue(campaign.trigger)
        : getCampaignTriggerViewValue(null)
    case CampaignNode.TYPE.END:
      return 'End campaign'
    default:
      return ''
  }
}
